// extracted by mini-css-extract-plugin
export default {"Wrapper":"Tooltip_Wrapper__396Qv","Empty":"Tooltip_Empty__N1Bh3","Content":"Tooltip_Content__FZYH3"};